module.exports = __webpack_public_path__ + "img/00008.f36c9821.webp";